module.exports = __webpack_public_path__ + "static/media/14UNEP1.536a7cbe.jpg";